const PREFIX = 'card:visibility:';

export interface CardVisibilityProps {
    defaultFolded: boolean;
    onExpandedChange: (expanded: boolean) => void;
}

export function useCardVisibility(storageKey: string): CardVisibilityProps {
    const key = `${PREFIX}${storageKey}`;

    const stored = (() => {
        try {
            return window.localStorage.getItem(key);
        } catch {
            return null;
        }
    })();

    const defaultFolded = stored === 'false';

    const onExpandedChange = (expanded: boolean): void => {
        try {
            window.localStorage.setItem(key, String(expanded));
        } catch {
            // ignore
        }
    };

    return { defaultFolded, onExpandedChange };
}
